/** AUTO GENERATED FILE, DO NOT CHANGE MANUALLY */
/** SEE: api/ConstClassFactory */
import {ModuleProps} from './ModuleProps.model'
export const Module: ModuleProps = {
address: 'address',
addressType: 'addressType',
bankAccount: 'bankAccount',
businessNumbers: 'businessNumbers',
client: 'client',
clientMyAccount: 'clientMyAccount',
company: 'company',
companyContactPerson: 'companyContactPerson',
companyRelationCompany: 'companyRelationCompany',
dashboard: 'dashboard',
dossier: 'dossier',
dossierNote: 'dossierNote',
emailAddress: 'emailAddress',
emailAddressType: 'emailAddressType',
imapSync: 'imapSync',
invoice: 'invoice',
invoiceDefaultSettings: 'invoiceDefaultSettings',
invoiceExport: 'invoiceExport',
invoiceNumberSettings: 'invoiceNumberSettings',
invoicePrintTemplateSettings: 'invoicePrintTemplateSettings',
layout: 'layout',
person: 'person',
personNumbers: 'personNumbers',
phoneNumber: 'phoneNumber',
phoneNumberType: 'phoneNumberType',
product: 'product',
system: 'system',
systemSettings: 'systemSettings',
user: 'user',
userMyAccount: 'userMyAccount',
}